import type { FC, ReactNode } from 'react'
import type { Pillar } from '@/types'

import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { PillarSlider } from '@/components/content/pillar-slider'

interface HomePillarsProps {
    pillars: Pillar[]
}

export const HomePillars: FC<HomePillarsProps> = ({ pillars }): ReactNode => {
    return (
        <section id='topics' className='scroll-mt-20'>
            <Container className='py-16 sm:py-20'>
                <SectionHeading
                    eyebrow='The guides'
                    title='Ten guides, each one built to be read end to end'
                    description='Every guide is a complete reference on one part of everyday health, with in-depth articles underneath it. Start wherever you are today.'
                />

                <PillarSlider pillars={pillars} className='mt-12' />
            </Container>
        </section>
    )
}
